module.exports = __webpack_public_path__ + "static/media/prepaid_b08.d194c55b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prepaid_b08.png
// module id = 737
// module chunks = 21